import React from 'react';
import { FormattedMessage } from 'react-intl';
import InboxTransitionBase from './InboxTransitionBase';

const InboxTransitionPartyMembersSubmitted3 = ({ transition, buttons }) => {
  return (
    <InboxTransitionBase
      header={<FormattedMessage id="BookingStatus.transitionBookingStartGettingCloser" />}
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
    />
  );
};

export default InboxTransitionPartyMembersSubmitted3;
